// extracted by mini-css-extract-plugin
module.exports = {"FeaturedClients":"styles_FeaturedClients__v3BAX","bg_1":"styles_bg_1___Mff1","bg_2":"styles_bg_2__wVOEO","height":"styles_height__fnXQA"};